import { optionTypes } from "@/calculator/shared/Classes/BankClass";
import { testExcludedParams, testDopParams, } from "@/shared/scripts/TestAdsParams";
export const calcGetters = {
    getBankById: (state) => (id) => {
        const entry = Object.entries(state.banks).find(([key, bank]) => bank.id === id);
        return entry ? entry[1] : undefined;
    },
    getRate: (state, getters) => (id, rate = "minRate") => {
        const bank = state.banks[id];
        let calculatedRate = bank.fixedRate.rate !== 0 ? bank.fixedRate.rate : bank[rate];
        let plusAmount = 0;
        for (const type of optionTypes.plus) {
            const value = (bank[type].applied ? bank[type].value : 0);
            if (bank.insuranceIsSum) {
                plusAmount += value;
            }
            else if (plusAmount < value) {
                plusAmount = value;
            }
        }
        calculatedRate += plusAmount;
        [...optionTypes.minus].forEach((type) => {
            bank[type].applied
                ? (calculatedRate -= bank[type].value)
                : (calculatedRate += 0);
        });
        return Number(calculatedRate)
            .toFixed(2)
            .replace(/0*$/, "")
            .replace(/\.$/, "");
    },
    getFullCreditSum(state, getters) {
        const inputsValues = getters.inputsValues;
        /** Для потребов сумма кредита - поле с id 18**/
        if (getters.getIsConsumerCredit) {
            let sum = inputsValues[18];
            const addSum1379 = getters.inputsValues[1379] || 0;
            return sum + addSum1379;
        }
        const creditSum = inputsValues[151] !== undefined ? inputsValues[151] : 0;
        const creditType = inputsValues[-1] !== undefined ? inputsValues[-1] : 0;
        const addSum416 = inputsValues[416] !== undefined ? inputsValues[416] : 0;
        const addSum425 = inputsValues[425] !== undefined ? inputsValues[425] : 0;
        let fullCreditSum;
        if (creditType === 1182) {
            fullCreditSum = creditSum + addSum425 + addSum416;
        }
        else {
            fullCreditSum = creditSum;
        }
        return fullCreditSum;
    },
    getCreditTerm(state, getters) {
        let creditTerm;
        const inputsValues = getters.inputsValues;
        if (getters.getIsConsumerCredit) {
            creditTerm = inputsValues[17];
        }
        else {
            creditTerm = inputsValues[153] !== undefined ? inputsValues[153] : 0;
        }
        return creditTerm;
    },
    getPaymentByRate: (_, getters) => (rate) => {
        const fullCreditSum = getters.getFullCreditSum;
        let creditTerm = getters.getCreditTerm;
        return Math.ceil(fullCreditSum * (rate / (1 - (1 + rate) ** -creditTerm)));
    },
    getCalculatedPayment: (_, getters) => (id, rate = "minRate") => {
        const fullCreditSum = getters.getFullCreditSum;
        const monthRate = Number(getters.getRate(id, rate)) / 100 / 12;
        const inputsValues = getters.inputsValues;
        if (inputsValues[-1] === 2515) {
            return (Number(getters.getRate(id, rate)) / 100) * fullCreditSum;
        }
        return getters.getPaymentByRate(monthRate);
    },
    getCalculatedIncome: (state, getters) => (id, rate = "minRate") => {
        if (getters.getIsIncomeCredit)
            return 0;
        const bank = state.result.banks.find((bank) => bank.id === id);
        const payment = getters.getCalculatedPayment(id, rate);
        const isConsumerCredit = getters.getIsConsumerCredit;
        const numberOfDependents = state.financialBurden.numberOfDependents || 0;
        const lifeCost = isConsumerCredit ? bank.paramValues[2304] : bank.paramValues[2303];
        const childOutcome = isConsumerCredit ? bank.paramValues[1363] * numberOfDependents : bank.paramValues[75] * numberOfDependents;
        const paymentRate = isConsumerCredit ? bank.paramValues[1362] : bank.paramValues[193];
        const currentCredits = state.financialBurden.monthlyLoanPayments || 0;
        const creditCardPayments = isConsumerCredit
            ? (state.financialBurden.limitOfActiveCreditCards || 0) * bank.paramValues[1364] / 100
            : (state.financialBurden.limitOfActiveCreditCards || 0) > bank.paramValues[372] ? state.financialBurden.limitOfActiveCreditCards * bank.paramValues[74] / 100 : 0;
        const income1 = Math.ceil((payment + currentCredits + creditCardPayments) / (paymentRate / 100));
        const income2 = Math.ceil(lifeCost + childOutcome + payment + currentCredits + creditCardPayments);
        return Math.max(income1, income2);
    },
    getCheckedPromoCount: (state) => (id) => {
        if (state.banks[id] !== undefined) {
            return state.banks[id].countDiscount;
        }
    },
    showCommissionAndPreferenceIcon: (state) => (id) => {
        return (state.showRewardUser &&
            state.showPreferencesUser &&
            (state.banks[id]?.myCommission?.minValue > 0 ||
                state.banks[id]?.myCommission?.maxValue > 0 ||
                state.banks[id]?.commission?.minValue > 0 ||
                state.banks[id]?.commission?.maxValue > 0 ||
                state.banks[id]?.preferences?.value > 0 ||
                state.banks[id]?.myPreferences?.value > 0));
    },
    getIsConsumerCredit(state, getters) {
        const inputsValues = getters.inputsValues;
        return (inputsValues[-1] === 2514 ||
            inputsValues[-1] === 2515 ||
            inputsValues[-1] === 2516 ||
            inputsValues[-1] === 2801 ||
            inputsValues[-1] === 2896 ||
            inputsValues[-2] === 3);
    },
    getIsObjectLand(state, getters) {
        const inputsValues = getters.inputsValues;
        return !!inputsValues[389];
    },
    getIsAllRegions(state, getters) {
        const inputsValues = getters.inputsValues;
        return inputsValues[0] === 28;
    },
    getIsCreditCardCredit(state, getters) {
        const inputsValues = getters.inputsValues;
        return inputsValues[-1] === 2515;
    },
    getIsIslamicCredit(state, getters) {
        const inputsValues = getters.inputsValues;
        return inputsValues[382] === 2755 || inputsValues[-1] === 2758; // тип кредита === Исламская ипотека || тип кредита для потребов === Исламская дебетовая карта
    },
    getIsIslamicDebitCard(state, getters) {
        const inputsValues = getters.inputsValues;
        return inputsValues[-1] === 2758; // тип кредита для потребов === Исламская дебетовая карта
    },
    choosedBanksCalculator(state) {
        return state.choosedBanks;
    },
    calculatorInputs(state) {
        return state.categories
            .map((el) => el.inputs)
            .reduce((acc, category) => {
            return acc.concat(category);
        }, []);
    },
    inputsValues(state, getters) {
        const inputs = getters.calculatorInputs;
        const value = {};
        inputs.forEach((input) => {
            value[input.id] = input.value;
        });
        return value;
    },
    getTypesLoan(state) {
        return state.typesLoan;
    },
    getAppliedPromos(state) {
        const appliedPromos = [];
        Object.values(state.banks).forEach((el) => {
            if (el.promoActive > 0) {
                const promos = Object.values(el.promo)
                    .filter((promo) => promo.applied)
                    .map((promo) => promo.id);
                appliedPromos.push({
                    bankId: el.id,
                    promoIds: promos,
                    salaryProject: el.salaryProject.applied,
                });
            }
        });
        return appliedPromos;
    },
    getDataForReport: (state, getters, rootState, rootGetters) => (formData, banks) => {
        const inputsValues = getters.inputsValues;
        let creditTerm;
        if (getters.getIsConsumerCredit) {
            creditTerm = inputsValues[17];
        }
        else {
            creditTerm = inputsValues[153] !== undefined ? inputsValues[153] : 0;
        }
        return {
            ...formData,
            creditSum: getters.getFullCreditSum,
            creditTerm: creditTerm,
            banks: banks.map((bank) => {
                return {
                    id: bank.id,
                    name: state.banks[bank.id].name,
                    effectiveRateMin: state.banks[bank.id].effectiveRateMin,
                    effectiveRateMax: state.banks[bank.id].effectiveRateMax,
                    minRate: state.banks[bank.id].minRate,
                    maxRate: state.banks[bank.id].maxRate,
                    minIncome: getters.getCalculatedIncome(bank.id, "minRate"),
                    maxIncome: getters.getCalculatedIncome(bank.id, "maxRate"),
                    minPayment: getters.getCalculatedPayment(bank.id, "minRate"),
                    maxPayment: getters.getCalculatedPayment(bank.id, "maxRate"),
                    top: bank.top,
                    creditSum: rootGetters["banks/banks"].find(({ id }) => id === bank.id).credit || 0,
                };
            }),
            calcBySalary: getters.getIsIncomeCredit,
            salary: getters.getIsIncomeCredit ? getters.inputsValues[2298] : 0,
            pv: getters.getIsIncomeCredit ? getters.inputsValues[2299] : 0,
        };
    },
    getDataForLead: (state, getters) => (isConstructionCompany = false, id) => {
        if (isConstructionCompany) {
            return {
                parameters: state.parameters,
                id: id,
            };
        }
        else {
            const currentBank = state.banks[id];
            return {
                parameters: state.parameters,
                bankParams: {
                    id: currentBank.idMarketplace,
                    promo: Object.values(currentBank.promo)
                        .filter((el) => el.applied)
                        .map((el) => el.id),
                    salaryProject: currentBank.salaryProject.applied,
                    insuranceLife: currentBank.insuranceLife.applied,
                    insuranceTitle: currentBank.insuranceTitle.applied,
                    ac_id: [getters.getBankProductInfo(currentBank.idMarketplace)?.id],
                },
            };
        }
    },
    getDataForSiteLead: (state, getters) => (id) => {
        const currentBank = state.banks[id];
        const region_id = getters.inputsValues[0];
        return {
            parameters: state.parameters,
            bankParams: {
                promo: Object.values(currentBank.promo)
                    .filter((el) => el.applied)
                    .map((el) => el.id),
                salaryProject: currentBank.salaryProject.applied,
                insuranceLife: currentBank.insuranceLife.applied,
                insuranceTitle: currentBank.insuranceTitle.applied,
            },
            bank_id: currentBank.idMarketplace,
            region_id: region_id,
            website_type: currentBank.website_id,
        };
    },
    getIncompatibilityReducedRateWithPromos: (_) => (paidRateReduction, bank) => {
        //проверка на совместимость с акциями
        if (bank.promoActive > 0 &&
            (paidRateReduction.incompatibility_with_auto_promos ||
                paidRateReduction.incompatibility_with_manual_promos)) {
            const appliedPromos = Object.values(bank.allPromo).filter((promo) => promo.applied);
            let appliedHandlerPromos = [];
            let appliedAutoPromos = [];
            appliedPromos.forEach((el) => {
                (el.handler === 1 ? appliedHandlerPromos : appliedAutoPromos).push(el);
            });
            return !((paidRateReduction.incompatibility_with_auto_promos &&
                appliedAutoPromos.length) ||
                (paidRateReduction.incompatibility_with_manual_promos &&
                    appliedHandlerPromos.length));
        }
        else {
            return true;
        }
    },
    getShowTemplates(state) {
        return !!(state.templates.publicTemplates.length ||
            state.templates.selfTemplates.length ||
            state.templates.companyTemplates.length);
    },
    getBankLogoInfo2: (state) => (bankId) => {
        return state.banksLogos[bankId];
    },
    getIsBankWithFeedBack: (state, getters) => (bankId) => {
        const productId = state.parameters[-1]?.value;
        if (productId) {
            return !!getters.getBankProductInfo(bankId);
        }
        else {
            return !!state.bankAdvertises[bankId];
        }
    },
    getBankProductInfo: (state) => (bankId) => {
        let productInfo;
        const productId = state.parameters[-1]?.value;
        if (productId) {
            const products = state.bankAdvertises[bankId]?.products[productId];
            if (products) {
                const sortProducts = [...products].sort((a, b) => {
                    const paramsLength = (item) => {
                        return Object.values(item.params).filter((el) => el.length).length;
                    };
                    return paramsLength(a) < paramsLength(b) ? 1 : -1;
                });
                let index = 0;
                const findProduct = () => {
                    if (testExcludedParams(state.parameters, sortProducts[index].excluded_params) &&
                        testDopParams(state.parameters, sortProducts[index]?.params)) {
                        let bankInfo = sortProducts[index];
                        const btnName = bankInfo.button_name.length
                            ? bankInfo.button_name
                            : "Сайт";
                        const btn2Name = bankInfo.button_2_name.length
                            ? bankInfo.button_2_name
                            : bankInfo.button_2_type === 2
                                ? "Оставить заявку"
                                : "Действие";
                        productInfo = {
                            ...bankInfo,
                            button_name: btnName,
                            button_2_name: btn2Name,
                        };
                    }
                    else {
                        index++;
                        if (sortProducts[index]) {
                            findProduct();
                        }
                    }
                };
                findProduct();
            }
        }
        return productInfo;
    },
    getBankDefaultProduct: (state) => (bankId) => {
        return state.bankAdvertises[bankId]?.defaultProduct;
    },
    getCCById: (state) => (keyIndex) => {
        let productInfo;
        const productId = state.parameters[-1]?.value;
        const products = state.constructionCompanyAdvertises[keyIndex]?.products?.[productId];
        let index = 0;
        const testSum = (startSum, endSum) => {
            const objectCost = state.parameters[387]?.value;
            if ((startSum || endSum) && objectCost) {
                return objectCost >= startSum && objectCost <= endSum;
            }
            return true;
        };
        const findProduct = () => {
            if (testExcludedParams(state.parameters, products?.[index].excluded_params) &&
                testDopParams(state.parameters, products[index].params) &&
                testSum(products[index].start_sum, products[index].end_sum)) {
                productInfo = products[index];
            }
            else {
                index++;
                if (products?.[index]) {
                    findProduct();
                }
            }
        };
        if (products) {
            findProduct();
        }
        return productInfo;
    },
    getBanksForSentLeads: (state, getters) => {
        const selectedBankIds = Object.entries(state.banks).map((bank) => bank[1].idMarketplace);
        const leadsBanks = Object.entries(state.bankAdvertises)
            .map(([id, value]) => [
            id,
            value.defaultProduct,
        ])
            .filter(([id, value]) => getters.getIsBankWithFeedBack(id) &&
            value.button_2_type === 2 &&
            !state.submittedBankAdvertises.includes(value.id) &&
            selectedBankIds.includes(Number(id)));
        return leadsBanks;
    },
    // Проверка на расчет по доходу
    getIsIncomeCredit: (state, getters) => {
        const inputsValues = getters.inputsValues;
        return inputsValues[2297] === 3015 || inputsValues[2300] === 3015;
    },
    // Кредит для рассчета по доходу
    getIncomeBankCard: (state, getters) => (id) => {
        const getIncomePayment = () => {
            const bank = state.result.banks.find((bank) => bank.id === id);
            const inputsValues = getters.inputsValues;
            const income = inputsValues[2298] || inputsValues[2301] || 0;
            const pk = state.financialBurden.monthlyLoanPayments || 0;
            const kk = getters.getIsConsumerCredit
                ? ((state.financialBurden.limitOfActiveCreditCards || 0) * bank.paramValues[1364]) / 100
                : (state.financialBurden.limitOfActiveCreditCards || 0) > bank.paramValues[372]
                    ? (state.financialBurden.limitOfActiveCreditCards * bank.paramValues[74]) / 100
                    : 0;
            const izd = getters.getIsConsumerCredit
                ? bank.paramValues[1363] * state.financialBurden.numberOfDependents || 0
                : bank.paramValues[75] * state.financialBurden.numberOfDependents || 0;
            const lifeCost = getters.getIsConsumerCredit
                ? bank.paramValues[2304]
                : bank.paramValues[2303];
            const paymentPercent = bank.paymentPercent / 100 || 0.5;
            const payment1 = income * paymentPercent - pk - kk;
            const payment2 = income - lifeCost - pk - kk - izd;
            return Math.min(payment1, payment2);
        };
        const inputsValues = getters.inputsValues;
        const bank = state.result.banks.find((bank) => bank.id === id);
        const payment = getIncomePayment();
        const rate = getters.getRate(id) / 100;
        const term = inputsValues[153] || inputsValues[17] || 0;
        const maxCredit = bank.maxSumCreditWithRestrictions;
        const credit = (payment * (1 + rate / 12) ** -term * ((1 + rate / 12) ** term - 1)) / (rate / 12);
        const firstPayment = inputsValues[2299] || inputsValues[2302] || inputsValues[1965] || 0;
        if (credit > maxCredit) {
            const annuityPayment = calculateAnnuityPayment(maxCredit, rate, term);
            const annuityAmount = maxCredit + firstPayment;
            const overpayment = annuityPayment * term - maxCredit;
            return {
                payment: Math.round(annuityPayment).toLocaleString('ru-RU'),
                credit: Math.round(maxCredit).toLocaleString('ru-RU'),
                amount: Math.round(annuityAmount).toLocaleString('ru-RU'),
                overpayment: Math.round(overpayment).toLocaleString('ru-RU'),
            };
        }
        const amount = credit + firstPayment;
        const overpayment = payment * term - credit;
        return {
            payment: Math.round(payment).toLocaleString('ru-RU'),
            credit: Math.round(credit).toLocaleString('ru-RU'),
            amount: Math.round(amount).toLocaleString('ru-RU'),
            overpayment: Math.round(overpayment).toLocaleString('ru-RU'),
        };
    },
    isNoResult: (state, getters) => {
        return state.result.isLight ? state.result.light.banks === 0 : state.result.count === 0;
    },
    totalExcludedBanksCount(state, getters) {
        return state.excludedBanks.length;
    },
    processedExcludedBanksList: (state, getters) => {
        const resultBankIds = new Set(state.result.light?.banksData ||
            state.result.banks?.map(el => el.id_for_marketplace) ||
            []);
        return state.excludedBanks
            .filter(item => !resultBankIds.has(item.bank))
            .map(item => {
            const reasonParam = item.reason?.parameter || undefined;
            const parameterItem = getters.calculatorInputs.find(el => el.id == reasonParam) ||
                state.additionalParameters[String(reasonParam)];
            let parameterValue = '';
            const additionalItem = state.checkedAdditionalParameters[String(reasonParam)];
            if (additionalItem) {
                if (additionalItem === true)
                    parameterValue = "Да";
                else if (typeof additionalItem === 'number')
                    parameterValue = additionalItem.toString();
                else {
                    const value = state.additionalParameters[reasonParam]?.values
                        ?.find(val => val.id === additionalItem[0]);
                    parameterValue = value?.name || '';
                }
            }
            else if (parameterItem?.valueType === 'array') {
                parameterValue = parameterItem.values.find(el => el.id == parameterItem.value)?.name || '';
            }
            else {
                parameterValue = parameterItem?.value?.toString() || '';
            }
            const bankInfo = state.banksLogos[item.bank];
            return {
                key: `${item.bank}-${reasonParam}`,
                bankId: item.bank,
                bankName: bankInfo?.name || '',
                logo: bankInfo?.logo || '',
                logoMini: bankInfo?.logo_mini || '',
                parameterTitle: parameterItem?.name || '',
                parameterValue: parameterValue || '',
            };
        })
            .reverse();
    },
    getFinancialBurden(state) {
        return {
            loanPayments: state.financialBurden.monthlyLoanPayments || null,
            creditCardLimit: state.financialBurden.limitOfActiveCreditCards || null,
            dependents: state.financialBurden.numberOfDependents || null,
            reduceForCommission: state.financialBurden.rateReductionPayment || null
        };
    },
    getInsurance(state) {
        const insurance = [];
        for (const key in state.banks) {
            if (state.banks[key].insuranceLife.applied || state.banks[key].insuranceTitle.applied) {
                insurance.push({
                    bankId: state.banks[key].id,
                    life: state.banks[key].insuranceLife.applied,
                    title: state.banks[key].insuranceTitle.applied,
                });
            }
        }
        return insurance;
    }
};
function calculateAnnuityPayment(sum, percent, months) {
    const monthlyRate = percent / 12; // Месячная ставка
    const coefficient = (monthlyRate * Math.pow(1 + monthlyRate, months)) /
        (Math.pow(1 + monthlyRate, months) - 1);
    const payment = sum * coefficient;
    return Math.round(payment);
}
